<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5674 1.82178L15.1338 7.99951L11.5674 14.1782H4.43262L0.865234 7.99951L4.43262 1.82178H11.5674Z" stroke="currentColor" stroke-width="1.5"/>
</svg>
